<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <div class="flex align-items-center gap-4 mb-4">
                <div class="w-6rem h-6rem bg-gray-100 border-round flex align-items-center justify-content-center">
                    {{emprunt.employe?.prenom?.charAt(0)}}{{emprunt.employe?.nom?.charAt(0)}}
                </div>
                <div>
                    <div class="flex align-items-center gap-3 mb-1">
                        <h5 class="m-0">Emprunt</h5>
                        <span class="statut {{emprunt.statut.nom | statut}}">{{emprunt.statut.nom}}</span> 
                    </div>
                    <div class="flex align-items-center gap-1 mb-1">
                        <span class="text-lg">{{emprunt.item?.numero}} - {{emprunt.item?.description}}</span>
                    </div>
                    <div class="text-600">
                        Emprunté par: {{emprunt.employe?.prenom}} {{emprunt.employe?.nom}}
                    </div>
                </div>
            </div>
            
            <p-menubar autoDisplay="false" [model]="menu">
                <p-button *ngIf="(estAutorise('admin_emprunt') || emprunt.demandeParId == profilService.ProfilCourant().employeId) && modeConsultation()"
                    (click)="surBoutonModifier()" icon="pi pi-pencil" styleClass="p-button-primary"></p-button>
                <p-button *ngIf="modeAjoutModification()" (onClick)="enregistrerModifications()" 
                    icon="pi pi-check" styleClass="p-button-success mr-2">
                </p-button>
                <p-button *ngIf="modeAjoutModification()" (onClick)="surBoutonAnnulerModification($event)"
                    icon="pi pi-times" styleClass="p-button-secondary"></p-button>
            </p-menubar>
        </p-card>
    </div>
</div>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-tabView [scrollable]="true" orientation="left">
                <p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
                    <div class="fluid formgrid grid">
                        
                        <!-- Item Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6">
                            <div class="flex align-items-center gap-2">
                                <label class="font-semibold">Item</label>
                                <a [routerLink]="['/item', emprunt.item?.itemId]">
                                    <i class="pi pi-external-link"></i>
                                </a>
                            </div>
                            <div>{{emprunt.item?.numero}} - {{emprunt.item?.description}}</div>
                        </div>

                        <!-- Employee Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6">
                            <div class="flex align-items-center gap-2">
                                <label class="font-semibold">Employé</label>
                                <a [routerLink]="['/employe', emprunt.employe?.employeId]">
                                    <i class="pi pi-external-link"></i>
                                </a>
                            </div>
                                <app-employe-avec-emplacement [employe]="emprunt.employe"></app-employe-avec-emplacement>
                        </div>

                        <!-- Departure Location Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6">
                                <label class="font-semibold">Lieu de départ</label>
                                <div>
                                    {{emprunt.emplacementDepart?.nom | valeurVide}}
                                </div>
                        </div>

                        <!-- Return Location Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6" *ngIf="emprunt.dateRetour">
                            <label class="font-semibold">Lieu de retour</label>
                            <div>
                                {{emprunt.emplacementRetour?.nom | valeurVide}}
                            </div>
                            <div *ngIf="!modeConsultation()">
                                <div class="p-inputgroup mb-2">
                                    <input type="text" pInputText readonly
                                        [value]="emprunt?.emplacementRetour ? emprunt?.emplacementRetour?.nom : 'Aucun emplacement sélectionné'"
                                        placeholder="Sélectionner un emplacement"
                                        (click)="selectionnerEmplacement(true)" [disabled]="emprunt?.employeRetour">
                                    <button *ngIf="!emprunt?.emplacementRetour" type="button" pButton icon="pi pi-search" class="p-button-outlined" [disabled]="emprunt?.employeRetour"
                                        pTooltip="Sélectionner un emplacement"
                                        (click)="selectionnerEmplacement(true)">
                                    </button>
                                    <button *ngIf="emprunt?.emplacementRetour" type="button" pButton icon="pi pi-times" class="p-button-outlined"
                                        pTooltip="Supprimer l'emplacement de retour"
                                        (click)="emprunt.emplacementRetour = null; emprunt.emplacementRetourId = null;">
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Dates Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6">
                            <label class="font-semibold">Dates</label>
                            <div class="flex flex-column gap-2">
                                <div>
                                    Créé le {{emprunt.dateCreation | date:'dd/MM/yyyy'}}
                                </div>
                                <div>
                                    Affecté le {{emprunt.dateAffectation | date:'dd/MM/yyyy'}}
                                </div>
                                <div *ngIf="emprunt.dateRetour" class="flex flex-column gap-2">
                                    Retour le <div *ngIf="modeConsultation()">{{emprunt.dateRetour | date:'dd/MM/yyyy'}}</div>
                                    <div *ngIf="!modeConsultation()"><p-calendar [(ngModel)]="emprunt.dateRetour" dateFormat="dd MM yy" [showIcon]="true" inputId="dateRetour"
                                        placeholder="Sélectionner la date de retour" [minDate]="minDateRetour"></p-calendar></div>
                                </div>
                            </div>
                        </div>

                        <!-- Notes Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12 lg:col-6" *ngIf="emprunt.note">
                            <label class="font-semibold">Notes</label>
                            <p *ngIf="modeConsultation()" class="formatted-text">{{emprunt.note}}</p>
                            <textarea pInputTextarea *ngIf="!modeConsultation()" [(ngModel)]="emprunt.note" [style]="{'height':'120px'}" rows="3"></textarea>
                        </div>

                        <!-- Request Information -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12" *ngIf="emprunt.employeDemandePar">
                            <label class="font-semibold">Demandé par</label>
                            <app-employe-avec-emplacement [employe]="emprunt.employeDemandePar"></app-employe-avec-emplacement>
                        </div>

                        <!-- Children Section -->
                        <div class="sihc-field flex flex-column gap-2 my-3 col-12" *ngIf="emprunt.empruntEnfants.length > 0">
                            <label class="font-semibold">Items liés</label>
                            <div>
                                <p-dataView [value]="emprunt.empruntEnfants">
                                    <ng-template pTemplate="list" let-items>
                                        @for (item of items; track item.empruntEnfantId) {
                                            <p-card [styleClass]="'mb-2 w-full'">
                                                <!-- Status indicator for inactive items -->
                                                <div *ngIf="item.dateRetrait" class="flex align-items-center gap-2 mb-2 p-2 border-round">
                                                    <i class="pi pi-history text-orange-600"></i>
                                                    <span class="text-orange-700 font-semibold text-sm">HISTORIQUE - Item retiré de cet emprunt</span>
                                                </div>

                                                <div class="flex justify-content-between gap-2">
                                                    <div class="flex align-items-start gap-3">
                                                        <!-- Image -->
                                                        <div class="flex-shrink-0">
                                                            <div *ngIf="item.item.photoId" class="w-4rem h-4rem">
                                                                @defer (on viewport) {
                                                                <app-image-loader [documentId]="item.item.photoId" [width]="64" [height]="64" [title]="item.item.numero"></app-image-loader>
                                                                }
                                                                @placeholder {
                                                                    <div class="flex align-items-center justify-content-center border-1 border-300 border-round" style="height: 64px; width: 64px;">
                                                                        <p-skeleton width="64px" height="64px"></p-skeleton>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div *ngIf="!item.item.photoId" class="w-4rem h-4rem border-1 border-300 border-round flex align-items-center justify-content-center">
                                                                <i class="pi pi-image text-gray-500"></i>
                                                            </div>
                                                        </div>
                                                        
                                                        <!-- Item Information -->
                                                        <div class="flex-1">
                                                            <div class="flex flex-column gap-2">
                                                                <div class="flex align-items-center gap-2">
                                                                    <span class="font-bold text-lg">{{item.item.numero}}</span>
                                                                    <span *ngIf="!item.dateRetrait" class="bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 border-round">ACTIF</span>
                                                                </div>
                                                                <div class="text-600 line-height-3">
                                                                    {{item.item.description}}
                                                                </div>
                                                                <div class="flex flex-wrap gap-3 text-sm">
                                                                    <div *ngIf="item.item.marque" class="flex align-items-center gap-1">
                                                                        <span class="text-500">Marque:</span>
                                                                        <span class="font-medium">{{item.item.marque}}</span>
                                                                    </div>
                                                                    <div *ngIf="item.item.modele" class="flex align-items-center gap-1">
                                                                        <span class="text-500">Modèle:</span>
                                                                        <span class="font-medium">{{item.item.modele}}</span>
                                                                    </div>
                                                                </div>

                                                                <!-- Date Information Section -->
                                                                <div class="mt-2 p-2">
                                                                    <!-- Show DateAjout only if it differs from emprunt DateCreation -->
                                                                    <div *ngIf="shouldShowDateAjout(item)" class="flex align-items-center gap-2 mb-1">
                                                                        <i class="pi pi-plus-circle text-blue-600"></i>
                                                                        <span class="text-sm">
                                                                            <span class="font-semibold">Ajouté le:</span> 
                                                                            {{item.dateAjout | date:'dd/MM/yyyy à HH:mm'}}
                                                                            <span *ngIf="item.ajouteParEmploye"> par <app-employe-avec-emplacement [employe]="item.ajouteParEmploye"></app-employe-avec-emplacement></span>
                                                                        </span>
                                                                    </div>
                                                                    
                                                                    <!-- Show DateRetrait if available -->
                                                                    <div *ngIf="item.dateRetrait" class="flex align-items-center gap-2">
                                                                        <i class="pi pi-minus-circle text-orange-600"></i>
                                                                        <span class="text-sm">
                                                                            <span class="font-semibold">Retiré le:</span> 
                                                                            {{item.dateRetrait | date:'dd/MM/yyyy à HH:mm'}}
                                                                            <span *ngIf="item.retraitParEmploye"> par <app-employe-avec-emplacement [employe]="item.retraitParEmploye"></app-employe-avec-emplacement></span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p-button icon="pi pi-external-link" (click)="afficherItem(item.item.itemId)" text pTooltip="Afficher un apperçu de l'item"></p-button>
                                                </div>
                                            </p-card>
                                        }
                                    </ng-template>
                                </p-dataView>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Additional tabs can be added here for documents, history, etc. -->
                
            </p-tabView>
        </p-card>
    </div>
</div> 

<p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left" appendTo="body">
    <app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
</p-sidebar>